import React from 'react';
import ProgressBar from './ProgressBar';

const LoadingIndicator = ({
  type = 'progress', // 'progress', 'spinner', 'minimal'
  progress = 0,
  total = 100,
  label = 'Cargando...',
  size = 'medium',
  color = 'blue',
  className = '',
  showPercentage = true,
  centered = true
}) => {
  const containerClasses = centered
    ? 'flex flex-col justify-center items-center'
    : 'w-full';

  if (type === 'spinner') {
    return (
      <div className={`${containerClasses} ${className}`}>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        {label && <p className="mt-2 text-sm text-gray-600">{label}</p>}
      </div>
    );
  }

  if (type === 'minimal') {
    return (
      <div className={`${containerClasses} ${className}`}>
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
          {label && <span className="text-sm text-gray-600">{label}</span>}
        </div>
      </div>
    );
  }

  // Default: progress bar
  return (
    <div className={`${containerClasses} ${className}`}>
      <div className="w-full max-w-md">
        <ProgressBar
          progress={progress}
          total={total}
          showPercentage={showPercentage}
          color={color}
          size={size}
          label={label}
          animated={true}
        />
      </div>
    </div>
  );
};

export default LoadingIndicator;